import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { Text, ThemeTextColorPath } from 'platform/foundation-tw';
import { CurrencyFormat, useFormatCurrency } from 'platform/locale';
import { isNil, join, pipe, split } from 'ramda';
import { isNotNilOrEmpty, mapIndexed } from 'ramda-adjunct';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getStylesToRender } from '../../utils/getStylesToRender';
import { getTooltipProps } from '../../utils/getTooltipProps';
type MoneyValue = {
  amount: number;
  currency: string;
} | null;
type MoneyWithoutDecimalCellRendererProps = CellRendererProps<MoneyValue> & {
  getTooltipProps?: TooltipGetter;
};
type CellStyle = {
  textColor?: ThemeTextColorPath;
};
const removeDecimal = (val: string, index: number): string => {
  if (index === 1) {
    return val.slice(2);
  }
  return val;
};
const formatMoney = pipe<string[], [string, string], [string, string], string>(
// @ts-ignore
split(','), mapIndexed(removeDecimal), join(' '));
export function MoneyWithoutDecimalCellRenderer(props) {
  const $ = _c(27);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  let t1;
  if ($[2] !== props) {
    t1 = getStylesToRender(props);
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const cellStyles = t1 as CellStyle | undefined;
  const formatCurrency = useFormatCurrency();
  let t2;
  if ($[4] !== props.getTooltipProps || $[5] !== props.row) {
    t2 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[4] = props.getTooltipProps;
    $[5] = props.row;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const tooltipProps = t2;
  if (isNil(props.value)) {
    return null;
  }
  let t3;
  let t4;
  if ($[7] !== formatCurrency || $[8] !== props.value.amount || $[9] !== props.value.currency) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const value = isNotNilOrEmpty(props.value.amount) ? formatCurrency(props.value.amount, props.value.currency, 2) : null;
      if (isNil(value)) {
        t4 = null;
        break bb0;
      }
      t3 = formatMoney(value);
    }
    $[7] = formatCurrency;
    $[8] = props.value.amount;
    $[9] = props.value.currency;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  const formattedMoney = t3 as string;
  const t5 = cellStyles?.textColor;
  const t6 = !props.column?.wrapText;
  const t7 = props.column?.wrapText ? "anywhere" : undefined;
  let t8;
  if ($[12] !== props.value.amount || $[13] !== props.value.currency) {
    t8 = <CurrencyFormat currency={props.value.currency} number={props.value.amount} decimals={0} />;
    $[12] = props.value.amount;
    $[13] = props.value.currency;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = <Text color={t5} noWrap={t6} size="small" overflowWrap={t7}>{t8}</Text>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== className || $[21] !== t9) {
    t10 = <div className={className}>{t9}</div>;
    $[20] = className;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== formattedMoney || $[24] !== t10 || $[25] !== tooltipProps) {
    t11 = <Tooltip {...tooltipProps} label={formattedMoney}>{t10}</Tooltip>;
    $[23] = formattedMoney;
    $[24] = t10;
    $[25] = tooltipProps;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
}